import type {
  Property,
  PropertyRule,
  PropertyType,
  PropertyTypeFeature,
  PropertyTypeRule,
} from "../types";

import {mergeHouseholdPropertyRules} from "./household-property-rules";

/** API may return rule.feature as "permanent_parking" while section key is "permanentparking". */
const SECTION_TO_RULE_FEATURE: Record<string, string[]> = {
  permanentparking: ["permanentparking", "permanent_parking"],
};

function findPropertyRuleForTypeRule(
  propertyRules: PropertyRule[],
  typeRule: PropertyTypeRule,
): PropertyRule | undefined {
  return (
    propertyRules.find((pr) => pr.key === typeRule.key) ??
    propertyRules.find((pr) => pr.id === typeRule.rule_id)
  );
}

/**
 * Merges property-type rules for a feature with property overrides (Features tab pattern).
 * Property override wins when present; otherwise the type template value is kept.
 */
export function mergePropertyFeatureRules(
  featureKey: PropertyTypeFeature,
  typeRules: PropertyTypeRule[],
  propertyRules: PropertyRule[],
): PropertyTypeRule[] {
  if (featureKey === "households") {
    return mergeHouseholdPropertyRules(typeRules, propertyRules);
  }

  const ruleFeatureKeys = SECTION_TO_RULE_FEATURE[featureKey] ?? [featureKey];
  return typeRules
    .filter((rule) => ruleFeatureKeys.includes(rule.feature as string))
    .map((rule) => {
      const propertyRule = findPropertyRuleForTypeRule(propertyRules, rule);
      const value =
        propertyRule?.value !== undefined && propertyRule?.value !== null
          ? propertyRule.value
          : rule.value;
      return {...rule, value};
    });
}

export function findPropertyTypeForProperty(
  propertyTypes: PropertyType[],
  property: Property,
): PropertyType | undefined {
  const typeId = property.type?.id;
  if (typeId == null) return undefined;
  return propertyTypes.find((t) => Number(t.property_type_id) === Number(typeId));
}
